module.exports = __webpack_public_path__ + "static/media/person5.64cc99d0.svg";